import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4f2bfb3b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2bfb3b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f2bfb3b')) {
      api.createRecord('4f2bfb3b', component.options)
    } else {
      api.reload('4f2bfb3b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4f2bfb3b&scoped=true", function () {
      api.rerender('4f2bfb3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/orderpay/index.vue"
export default component.exports